import React from "react";

function Footer() {
  const footerStyle = {
    marginTop: "40px",
    textAlign: "center",
    fontSize: "14px",
    color: "#666",
  };

  return (
    <footer style={footerStyle}>
      <hr />
      <p>© {new Date().getFullYear()} John Gallagher - All Rights Reserved</p>
    </footer>
  );
}

export default Footer;
